import React from "react";
import { useTranslation } from "src/context/Translations/context";
import IComponentSelect from "react-common-components/dist/components/Select/interface";
import Select from "src/components/Select";

const LovTrashTables: React.FC<Omit<IComponentSelect,"options" | "label">> = ({
	name,
	control,
	defaultValue,	
	...rest
}) => {
	const { translate} = useTranslation();
	return (
		<Select
			control={control}
			name={name}
			label={translate("Categoria")}
			options={[
				{ value: "oftba001", label: translate("Plano orçamentário") }
			]}
			defaultValue={defaultValue || "oftba001"}
			{...rest}
		/>
	);
};

export default LovTrashTables;
